import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { SiteConfigPageProps } from './components/SiteConfigPage.tsx';

export const ShareableLinkSiteAdminConfigurationLoader: LoadableType<
	Omit<SiteConfigPageProps, 'flags'>
> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinkSiteConfiguration" */ './components/SiteConfigPage.tsx'
			)
		).SiteConfigPage,
});
